import { render, staticRenderFns } from "./complexNews.vue?vue&type=template&id=2bee8017&scoped=true&"
import script from "./complexNews.vue?vue&type=script&lang=js&"
export * from "./complexNews.vue?vue&type=script&lang=js&"
import style0 from "./complexNews.vue?vue&type=style&index=0&id=2bee8017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee8017",
  null
  
)

export default component.exports